// extracted by mini-css-extract-plugin
var _1 = "TagProgress-modulebar__xRJhY";
var _2 = "TagProgress-modulefill__luC19";
export { _1 as "bar", _2 as "fill" }
